import React from 'react';
import { Input } from 'antd';
import { useTranslation } from 'react-i18next';

interface Props {
    value: string;
    onChange: (value: string) => void;
    /** 搜索态用不同的标题文案，让用户明确当前看到的是过滤后的结果 */
    searching: boolean;
}

/**
 * 专题分析二级栏顶部：看板搜索框 + 标题。
 *
 * 通过 `MainLayout.secondHeader` 插槽塞进二级栏（WMS / TMS / 揽收 / 配送四个布局
 * 也是用这个插槽放仓库、Hub 选择器的），所以不需要自建一整列 —— 自建会和
 * MainLayout 恒定渲染的那一列并排出现两列。
 *
 * 搜索是**纯本地过滤**已加载的菜单树，不发请求：二级栏的数据一次就全在手上了。
 */
const DataPortalMenuHeader: React.FC<Props> = ({ value, onChange, searching }) => {
    const { t } = useTranslation();
    return (
        <div className="px-4 pb-2">
            <Input
                size="middle"
                allowClear
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={t('pages.dataPortal.searchPlaceholder') as string}
            />
            <div className="mt-2 text-xs text-gray-400">
                {searching
                    ? t('pages.dataPortal.searchResultHeading')
                    : t('pages.dataPortal.allBoardsHeading')}
            </div>
        </div>
    );
};

export default DataPortalMenuHeader;
